import { ALL_MEDAL_PROPERTIES } from './medalProperties';
/**
 * These values correspond to server-side enums and database values.
 */
export const ALL_MEDAL_TYPES = [
    'pp',
    'chips',
    'hands_played',
    'royal',
    'insomniac',
    'piggy',
    'champs',
    'rocket',
    'old_timer',
    'riot',
    'bad_beat_jackpot_winner',
    'sidebet_tokens',
    'sidebets_won'
];
export function isSupportedMedal(str) {
    return ALL_MEDAL_TYPES.includes(str) && !ALL_MEDAL_PROPERTIES[str].isDisabled;
}
